import List from './list';
import { FilterColumnModel } from '@/models/filter_column';

export class FilterColumnList extends List<FilterColumnModel> {

}
